import axios from 'axios';
import { SessionStore } from '../../types/store/SessionStore';
import { newAbortSignal } from '../../utils';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/files`;

export const deleteFile = async (fileId: number): Promise<void> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  await axios.delete(`${BASE_URL}/${fileId}`, {
    headers: {
      'x-access-token': session?.accessToken,
    },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });
};
